/**
 *
 * EmailPreference/CopyEmailTemplate
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'

// Components
import UserSelectWithModal from 'components/UsersSelect/Modal'

function CopyEmailTemplate({ email_template, select_user = false, blocked, copyEmailTemplate }) {
	if (select_user)
		return (
			<UserSelectWithModal
				button={
					<button className="btn btn-primary btn-sm ml-1" disabled={blocked}>
						Copy
					</button>
				}
				title="Who would you like to create this email template for?"
				paragraph="Campaigns exist under the primary user account for your company (typically the advisor's account). Please select the primary user below."
				onSelect={(user) => copyEmailTemplate({ user_id: user.id, id: email_template.id })}
			/>
		)

	return (
		<button
			className="btn btn-primary btn-sm ml-1"
			onClick={() => copyEmailTemplate({ id: email_template.id })}
			disabled={blocked}
		>
			Copy
		</button>
	)
}

CopyEmailTemplate.propTypes = {
	email_template: PropTypes.object,
	copyEmailTemplate: PropTypes.func,
	select_user: PropTypes.bool,
	blocked: PropTypes.bool,
}

CopyEmailTemplate.defaultProps = {}

export default CopyEmailTemplate
